import { useEffect, useRef } from 'react';

import { KYCStatus } from '~/api/KYCStatus';
import { SECOND } from '~/constants/variables';

import { userStore } from '~/stores';

/**
 * Hook to check user verification status periodically
 * Used in CartV3 to update KYC status
 */
export const useUserVerificationStatusChecker = () => {
  const verificationStatusInterval = useRef<ReturnType<
    typeof setInterval
  > | null>(null);
  const canCheckStatus =
    userStore.personalData.kycStatus !== KYCStatus.Verified &&
    userStore.isAuthorized;

  useEffect(() => {
    if (canCheckStatus) {
      userStore.requestPersonalData(true);
    }
  }, [canCheckStatus]);

  useEffect(() => {
    if (canCheckStatus) {
      verificationStatusInterval.current = setInterval(() => {
        userStore.requestPersonalData(true);
      }, 15 * SECOND);
    }
    return () => {
      if (verificationStatusInterval.current) {
        return clearInterval(verificationStatusInterval.current);
      }
    };
  }, [userStore.isAuthorized, userStore.personalData.kycStatus]);
};
